import { useState, useEffect } from 'react'
import { Input, Divider } from 'antd'
import SectionCharacter from './sectioncharacter'
import './characterindex.css'

const Character = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 300)
    return () => clearTimeout(timeout)
  }, [searchTerm])

  return (
    <div>
      <div className="container">
        <Input
          placeholder="Search by Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: '12%' }}
          allowClear
        />
      </div>
      <Divider style={{ margin: '10px 0' }} />
      <div className="sections-container">
        <SectionCharacter searchTerm={debouncedSearchTerm} />
      </div>
    </div>
  )
}

export default Character
